import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { fetch } from '~helpers/graphql';
import * as queries from '~settings/queries';

import PropertyDetailWrapper from '~components/property-detail-wrapper';
import { onlyViewPropertyRole } from '~client/helpers/auth';
import SelfSetting from './selfSetting';

const PropertyTag = ({ property, afterSave }) => {
  const { t } = useTranslation(['cms', 'landlord']);
  const { lowestPriceAt, lastOrderAt, lastViewAt, lastLandlordResponseAt, sellingPoints } =
    property;
  const [selfSettingTags, setSelfSettingTags] = useState(sellingPoints);

  const getDuration = (time, dataParams) => moment().diff(moment(time), dataParams);

  const diffLowestPriceAt = getDuration(lowestPriceAt, 'days');

  const diffLastOrderAt = getDuration(lastOrderAt, 'hours');

  const difflastViewAt = getDuration(lastViewAt, 'hours');

  const difflastResponse = getDuration(lastLandlordResponseAt, 'hours');

  const tagsArr = [
    {
      title: 'lowestPrice',
      showtag: lowestPriceAt ? diffLowestPriceAt >= 30 : false,
      duration: lowestPriceAt ? diffLowestPriceAt : 0,
      translation:
        lowestPriceAt && diffLowestPriceAt >= 30
          ? t('cms.property_detail.tag.lowest_price.desc', { duration: diffLowestPriceAt })
          : '',
    },
    {
      title: 'lastOrderAt',
      showtag: lastOrderAt ? diffLastOrderAt <= 48 : false,
      duration: lastOrderAt ? diffLastOrderAt : 0,
      translation:
        lastOrderAt && diffLastOrderAt <= 48
          ? diffLastOrderAt <= 1
            ? t('cms.property_detail.tag.last_order_at.simple_desc', {
                duration: diffLastOrderAt === 0 ? 1 : diffLastOrderAt,
              })
            : t('cms.property_detail.tag.last_order_at.desc', {
                duration: diffLastOrderAt,
              })
          : '',
    },
    {
      title: 'lastViewAt',
      showtag: lastViewAt ? difflastViewAt <= 48 : false,
      duration: lastViewAt ? difflastViewAt : 0,
      translation:
        lastViewAt && difflastViewAt <= 48
          ? difflastViewAt <= 1
            ? t('cms.property_detail.tag.last_view_at.simple_desc', {
                duration: difflastViewAt === 0 ? 1 : difflastViewAt,
              })
            : t('cms.property_detail.tag.last_view_at.desc', {
                duration: difflastViewAt,
              })
          : '',
    },
    {
      title: 'lastLandlordResponseAt',
      showtag: lastLandlordResponseAt && difflastResponse <= 24 ? true : false,
      translation:
        lastLandlordResponseAt && difflastResponse <= 24
          ? t('cms.property_detail.tag.last_landlord_response_at.desc')
          : '',
    },
  ];

  const handleSave = (callback = () => {}) => {
    const sellingPointIds = selfSettingTags?.filter(tag => tag?.checked)?.map(point => point?.id);
    fetch(
      queries.bindPropertySellingPoint({
        sellingPointIds,
        propertyId: property.id,
      }),
    )
      .then(res => {
        if (res?.bindPropertySellingPoint?.result) {
          afterSave({ ...property, sellingPoints: selfSettingTags });
          callback({ status: 'success', isUpdated: true });
        }
      })
      .catch(e => {
        callback({ status: 'err', err: e });
      });
  };

  return (
    <PropertyDetailWrapper
      t={t}
      isPublished={property.status === 'PUBLISHED'}
      onClickSave={handleSave}
      property={property}
      canEdit={!onlyViewPropertyRole()}
    >
      <div className="property-tag__box">
        <p className="property-detail__subtitle">{t('cms.property_detail.tag.sub_title')}</p>
        <div className="property-tag__tag--box">
          <For each="item" of={tagsArr} index="index">
            <If condition={item.showtag}>
              <div className="property-tag__tag--btn">{item?.translation}</div>
            </If>
          </For>
        </div>

        <SelfSetting
          t={t}
          selfSettingTags={selfSettingTags}
          setSelfSettingTags={setSelfSettingTags}
        />
      </div>
    </PropertyDetailWrapper>
  );
};

export default PropertyTag;
